export default __webpack_public_path__ + "static/media/auman_8.78853e41.png";